<template>
<profile-edit></profile-edit>
</template>

<script>
import ProfileEdit from '@/app/components/profile/ProfileEdit';
export default {
    name: 'Profile',
    components:{
        ProfileEdit
    },
    data(){
        return {
        }
    },
    methods: {

    },
    computed: {
    }
}
</script>
